// ARMS visual defaults. These are the floor — operator overrides and
// per-user overrides layer on top. Living in one file makes them easy
// to find when product ships its first brand-refresh.

export const ARMS_PRIMARY_HEX = '#1f3b6f';
export const ARMS_ACCENT_HEX  = '#7d4f8f';

/** Background tones for the home-dashboard tiles in light + dark modes. */
export const TILE_BG = {
  light: '#f6f7fa',
  dark:  '#1b2230',
} as const;
